import styled from 'styled-components';

export const EarningsPageWrap = styled.div`
  width: 100%;
  display: flex;
  > div {
    width: 50%;
  }
  @media (max-width: 800px) {
    flex-direction: column;
    > div {
      width: 100%;
    }
  }
`;
